module.exports = __webpack_public_path__ + "ci_vendor_stackdriver.641bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/ci_vendor_stackdriver.svg
// module id = ./src/_asset/sources/assets/images/ci_vendor_stackdriver.svg
// module chunks = main